import styled from "@emotion/styled"
import { Button, Drawer, IconButton, Typography } from "@mui/material"
import { useState } from "react"
import { CloseIcon, FilterIcon } from "ui"
import JobCategories from "./JobCategories"

const StyledMobileFilters = styled(Button)`
  width: 100%;
  height: 56px;
  border-radius: 12px;
  border: 1px solid #d1d5db;
  margin-bottom: 32px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  max-width: 100%;
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

const StyledDrawer = styled(Drawer)`
  & .MuiPaper-root {
    display: flex;
    border-radius: 25px 25px 0px 0px !important;
    overflow: hidden;
    min-height: 400px;
    max-height: 95%;
    overflow: scroll;
    /* Cards */
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.1);
    padding: 20px 16px 24px 16px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }
`

const TopBox = styled.div`
  position: relative;
  width: 100%;

  text-align: center;
`

const StyledIconButton = styled.div`
  position: absolute;
  top: 0px;
  left: 25px;
`

const StyledAppleButton = styled(Button)`
  width: 100%;
  height: 48px;
  background-color: #008761;
  border-radius: 12px;
  color: white;
`
type Props = {
  selectedCategories: any
  categories: string[]
  handleCategoryClick: (category: string) => void
  handleAllCategories: () => void
  handleMobileApplyFilters: () => void
}

const JobMobileCategory = ({
  selectedCategories,
  categories,
  handleAllCategories,
  handleCategoryClick,
  handleMobileApplyFilters,
}: Props) => {
  const [open, setOpen] = useState(false)

  const toggleDrawer = (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === "keydown" &&
      ((event as React.KeyboardEvent).key === "Tab" ||
        (event as React.KeyboardEvent).key === "Shift")
    ) {
      return
    }

    setOpen(!open)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <StyledMobileFilters onClick={() => setOpen(true)}>
        <FilterIcon />
        <Typography variant="body2">
          {" "}
          סינון:{" "}
          {selectedCategories.length > 0
            ? selectedCategories.join(", ")
            : " כל המשרות"}
        </Typography>
      </StyledMobileFilters>

      <StyledDrawer anchor="bottom" open={open} onClose={toggleDrawer}>
        <TopBox>
          <StyledIconButton>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </StyledIconButton>
          <Typography variant="h3">תחומים</Typography>
        </TopBox>
        <JobCategories
          categories={categories}
          selectedCategories={selectedCategories}
          handleCategoryClick={handleCategoryClick}
          handleAllCategories={handleAllCategories}
        />
        <StyledAppleButton
          onClick={() => {
            handleMobileApplyFilters()
            setOpen(false)
          }}
        >
          אישור
        </StyledAppleButton>
      </StyledDrawer>
    </>
  )
}

export default JobMobileCategory
